


















import { Component, Vue } from "vue-property-decorator";
import { templateApi } from "../api";

@Component({})
export default class TaskSaveTemplateModal extends Vue {
  title: string = "";

  public show() {
    (this.$refs.modal as any).show();
  }

  public hide() {
    this.title = "";
    (this.$refs.modal as any).hide();
  }

  async append() {
    const res = await templateApi.saveProjectTemplateTaskDuration({
      title: this.title,
      taskGroup: this.$store.state.task.taskGroups
    });

    if (res.id) {
      this.hide();

      return alert("工程プランが保存されました。");
    }

    alert(res || "工程プランの保存に失敗しました。");
  }

  cancel() {
    this.hide();
  }
}
